import { css, html } from "lit";
import { customElement } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import "@/components/icon";
import "@/components/tooltip";

@customElement("eko-page-header-tooltip")
class PageHeaderTooltip extends EkoElement {
  static styles = [
    ...EkoElement.styles,
    css`
      :host {
        cursor: help;
      }
    `,
  ];
  render() {
    return html`<eko-tooltip arrow>
      <eko-icon name="info-circle"></eko-icon>
      <span slot="content"><slot></slot></span>
    </eko-tooltip>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-page-header-tooltip": PageHeaderTooltip;
  }
}

export default PageHeaderTooltip;
